import { useTranslation } from "react-i18next";

import { Typography } from "@digital-services/ui";

import { Relationship } from "@resource/models";

interface CustomTooltipProps {
  items: Relationship[];
}

export const CustomTooltipForOwner = ({ items }: CustomTooltipProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "resource"
  });

  return (
    <div className="w-[300px]">
      <Typography className="mb-0.5 whitespace-nowrap" variant="smallTitle">
        {t("table.tooltip-title")}
      </Typography>
      <ul>
        {items.map(r => (
          <li key={`key-${r.entityId}`} className="text-xs">
            {r.entityName}
          </li>
        ))}
      </ul>
    </div>
  );
};
